export default {
  name: 'Call to action section - 5',
  tab: 'call to action',
  type: 'content-side-by-syde-section',
  content: {
    title: 'Call to action',
    introtext:
      '<p>Aenean lacinia bibendum nulla sed consectetur. Donec ullamcorper nulla non metus auctor fringilla. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.</p>',
    image: '/storage/media/samples/chris-abney-qLW70Aoo8BE-unsplash.jpg',
    buttons:
      '[{"button-style":"outlined","button-background-color":"var(--primary-color)","button-text-color":"inherit","button-text":"Read more","button-link":"#"},{"button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)","button-text":"Call to action","button-link":"#"}]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image': '',
    'parallax-background-image': '0',
    'custom-padding': '0',
    'padding-top': '60px',
    'padding-bottom': '60px',
    'title-color': 'inherit',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h4',
    'introtext-color': 'inherit'
  },
  layout: {
    'content-container-fluid': '0',
    container: '1',
    'content-container-size': 'xl',
    'content-horizontal-alignment': 'start',
    'content-vertical-alignment': 'start',
    'image-size': 'lg',
    'image-position': 'right',
    'content-box': '0',
    'content-box-color': 'black',
    'content-box-padding': '30px',
    'content-box-opacity': '0.5',
    'content-box-elevation': '0',
    'content-box-rounded': '0'
  },
  advanced: {}
}
